module.exports = __webpack_public_path__ + "assets/img/653100.f216c434.png";